/** @jsxImportSource @emotion/react */
import React from "react";
import { Button, Popover, Radio, RadioChangeEvent, Space } from "antd";
import { SizeType } from "antd/lib/config-provider/SizeContext";
import { TooltipPlacement } from "antd/lib/tooltip";
import { FileImageOutlined } from "@ant-design/icons";
import { ThumbnailSize } from "../types";

export interface ThumbnailSizeOption {
  label: string;
  value: ThumbnailSize;
}

const DEFAULT_OPTIONS: ThumbnailSizeOption[] = [
  { label: "Small", value: "small" },
  { label: "Medium", value: "medium" },
  { label: "Large", value: "large" },
];

export interface ToolboxThumbnailResizeProps {
  value: ThumbnailSize;
  onChange: (size: ThumbnailSize) => void;
  options?: ThumbnailSizeOption[];
  label?: string;
  icon?: React.ReactNode;
  size?: SizeType;
  placement?: TooltipPlacement;
}

export const ToolboxThumbnailResize: React.FC<ToolboxThumbnailResizeProps> = ({
  value,
  onChange,
  options = DEFAULT_OPTIONS,
  label = "Thumbnail Size",
  icon = <FileImageOutlined />,
  size = "large",
  placement = "bottomRight",
}: ToolboxThumbnailResizeProps) => {
  const handleChange = React.useCallback(
    (e: RadioChangeEvent) => {
      onChange(e.target.value as ThumbnailSize);
    },
    [onChange],
  );

  return (
    <Popover
      placement={placement}
      trigger="hover"
      content={
        <Radio.Group value={value} onChange={handleChange}>
          <Space direction="vertical">
            {options.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Space>
        </Radio.Group>
      }
    >
      <Button size={size} icon={icon}>
        {label}
      </Button>
    </Popover>
  );
};
